// Frontend mirror of backend planConfig.js — single source of truth for UI
// Keep in sync with flowsage-functions/functions/config/planConfig.js

const PLAN_LIMITS={
    free: {
        name: 'Flowsage Lite',
        projects: 5,
        nodesPerProject: 100,
        collaboratorsPerProject: 1,
        monthlyCredits: 5,
        features: {
            newestFeatures: false,
            prioritySupport: false,
        },
    },
    plus: {
        name: 'Flowsage Plus',
        projects: Infinity,
        nodesPerProject: Infinity,
        collaboratorsPerProject: 10,
        monthlyCredits: 150,
        stripe: {
            monthly: 'price_1P4ppSLBkoWM0o7BTlaXPC2I',
            annually: 'price_1P4ppiLBkoWM0o7B6dtOvUp8',
        },
        features: {
            newestFeatures: true,
            prioritySupport: false,
        },
    },
    premium: {
        name: 'Flowsage Pro',
        projects: Infinity,
        nodesPerProject: Infinity,
        collaboratorsPerProject: Infinity,
        monthlyCredits: Infinity,
        stripe: {
            monthly: 'price_1P4pn8LBkoWM0o7Bm1aaerfk',
            annually: 'price_1P4po4LBkoWM0o7BlZmePoyR',
        },
        features: {
            newestFeatures: true,
            prioritySupport: true,
        },
    },
};

export function getPlanLimits(plan) {
    return PLAN_LIMITS[plan]||PLAN_LIMITS.free;
}

export function formatLimit(value) {
    return value===Infinity? 'Unlimited':value;
}

export default PLAN_LIMITS;
